import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import paypalAdapter from 'shared/utils/adapters/payments/paypal';


const ACTIONS = createAsyncActions('SERVER.PAYMENTS.PAYPAL.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function (userId, instance) {
  return function (dispatch) {
    dispatch(START());

    return paypalAdapter.checkConnection(userId, instance)
      .then(
        function (result) {
          dispatch(SUCCESS({}, result));
          return result;
        },

        function () {
          dispatch(FAIL(null, null, { analytics: { type: 'error', name: 'shared.payments.paypal.get' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/payments/paypal/check-connection.js